<!--TODO add [routerLink]="link" back in pending https://github.com/dherges/ng-packagr/issues/478 -->

<nav class="drc-header-toolbar">
  <div class="drc-logo-wrapper">

    <a
      [href]=""
      class="drc-logo"
      alt="DRC Logo">
    </a>

  </div>
  <span class="client-name">{{clientTitle}}</span>
  <ng-content></ng-content>
  <div fxFlex fxLayout fxLayoutAlign="flex-end" fxLayoutGap="10px">
    <!-- <button  *ngIf="isAuthenticated" class="active mat-small-button" color="primary" (click)="logOut()"> Sign Out</button>
    <button  *ngIf="!isAuthenticated" class="active mat-small-button" color="primary" (click)="logIn()"> Sign In</button> -->
    <span class="mat-button-wrapper">
      @if (showHelp) {
        <a href="{{helpLink}}" target="_blank" style="color: #BFC2C5;"  >
          <mat-icon role="img" class="mat-icon notranslate help-menu-icon material-icons mat-icon-no-color" style="cursor:pointer" aria-hidden="true">help</mat-icon>
        </a>
      }
    </span>

  </div>

</nav>
